import HeaderContainer from './containers/HeaderContainer'

export default HeaderContainer
